import type { StatsSnapshot } from './gameplay-snapshot';
import { unitStats as stats } from './index';

export const updateAcademyStats = (state: StatsSnapshot) => {
  const academy = state.generators.academy;

  const generatedWizards = academy.owned * academy.baseGeneration;

  stats.academy = {
    unitsGeneration: generatedWizards,
  };
};
